export default {
  pdf: 'pdf',
  excel: 'excel',
  word: 'word'
}
